import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=0d4b2e21&scoped=true&"
import script from "./AlertBanner.vue?vue&type=script&lang=ts&"
export * from "./AlertBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=0d4b2e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b2e21",
  null
  
)

export default component.exports